import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-claro-complex-message',
  templateUrl: './claro-complex-message.component.html',
  styleUrls: ['./claro-complex-message.component.scss']
})
export class ClaroComplexMessageComponent {
  @Input() messageParts : ComplexMessagePartData[];
  partType = ComplexMessagePartType;
  @ViewChild('messageContainer') messageContainerRef: ElementRef;

  // restartAnimation(){
  //   console.log(`complexMessage restart animation`);
  //     // remove animation 
  //     this.messageContainerRef.nativeElement.style.animation = 'none';
    
  //   // trigger reflow
  //   this.messageContainerRef.nativeElement.offsetWidth;
    
  //   // add animation again
  //   this.messageContainerRef.nativeElement.animation = 'textgrowth 0.25s';
  // }
}

export enum ComplexMessagePartType {
  TEXT = 1,
  ICON = 2
}

export interface ComplexMessagePartData {
  type: ComplexMessagePartType;
  data: string;
  color?: string;
}
